import React from 'react';

const Grievance = () => {
  return (
    <div>
      Grievance
      Grievance
    </div>
  );
}

export default Grievance;
